import util from '@/utils/classToObject'
import { ICoverageIterationState } from './state'
import { AloDbCoverageIteration } from '@/models/alodb/AloDbCoverageIteration'

export class CoverageIterationGetter {  
      
  public coverageIterations(state:ICoverageIterationState,getters:any) {
    return state.coverageIterations
  }

  public modifiedAdmCoverageIteration(state:ICoverageIterationState,getters:any) {
    return state.modifiedAdmCoverageIteration
  }

  public originalAdmCoverageIteration(state:ICoverageIterationState,getters:any) {
    return state.originalAdmCoverageIteration
  }

  public coverageIterationLoading(state:ICoverageIterationState,getters:any) {
    return state.coverageIterationLoading
  }

  public coverageIterationsById(state:ICoverageIterationState) {     
    return state.coverageIterations.reduce((acc,value) =>{
        acc[value.COV_ID!] = value
        return acc
    },{}  as {[id:number]:AloDbCoverageIteration})      
  }

  public coverageIterationStatus(state:ICoverageIterationState) {     
    return state.status
  }

  public adminCoverageIterationFilter(state:ICoverageIterationState) {     
    return state.adminFilter
  }
  
}

export default util.classToObject(CoverageIterationGetter)